<template>
    <svg
        :height="height"
        :width="width"
        viewBox="0 0 15 14"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        :key="loadComponent"
    >
        <title>Star</title>
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g transform="translate(-208.000000, -144.000000)" :stroke="stroke" :fill="fill">
                <path
                    d="M219.550299,157.202282 L219.104682,152.883119 L222.043468,149.655416 L217.731208,148.739013 L215.5,144.979654 L213.268792,148.739013 L208.956532,149.655416 L211.895318,152.883119 L211.449701,157.202282 L215.5,155.450714 L219.550299,157.202282 Z"
                    id="Star"
                ></path>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    props: {
        height: {
            default: '14px',
        },
        width: {
            default: '15px',
        },
        stroke: {
            default: '#CFD1D2',
        },
        active: {
            default: false,
        },
    },
    computed: {
        fill() {
            return this.active ? '#CE0E2D' : false;
        },
    },
    watch: {
        active() {
            this.reloadComponent();
        },
    },
};
</script>
